/* Götze — add to cart from product cards.
   Button markup: snippets/gz-add-button.liquid · cart summary markup: snippets/gz-add-toast.liquid.
   Free-shipping threshold: data-threshold-usd on #gz-toast (keep equal to the cart's threshold setting, default 199). */
(function () {
  if (window.__gzAddInit) return;
  window.__gzAddInit = true;

  var routes = window.routes || {};
  var ADD_URL = (routes.cart_add_url || '/cart/add') + '.js';
  var CART_URL = (routes.cart_url || '/cart') + '.js';
  var closeTimer = null;

  function money(n, digits) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: digits, maximumFractionDigits: digits }).format(n);
    } catch (e) { return Math.round(n) + ' ' + cur; }
  }

  function setState(btn, state) {
    btn.classList.remove('is-adding', 'is-added', 'is-error');
    if (state === 'adding') btn.classList.add('is-adding');
    if (state === 'done') btn.classList.add('is-added');
    if (state === 'error') btn.classList.add('is-error');
    btn.setAttribute('aria-busy', state === 'adding' ? 'true' : 'false');
  }

  function updateCount(cart) {
    var link = document.querySelector('a[aria-label^="Cart ("]');
    if (!link) return;
    link.setAttribute('aria-label', 'Cart (' + cart.item_count + ')');
    var badge = link.querySelector('.gz-header__count');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'gz-header__count';
      link.appendChild(badge);
    }
    badge.textContent = cart.item_count;
  }

  function closeToast() {
    var t = document.getElementById('gz-toast');
    if (!t) return;
    t.classList.remove('is-open');
    t.hidden = true;
    clearTimeout(closeTimer);
  }

  function showToast(item, cart) {
    var t = document.getElementById('gz-toast');
    if (!t) return;
    var img = t.querySelector('[data-gz-toast-img]');
    var src = (item.featured_image && item.featured_image.url) || item.image || '';
    if (src) { img.src = src; img.parentNode.style.display = ''; } else { img.removeAttribute('src'); img.parentNode.style.display = 'none'; }
    t.querySelector('[data-gz-toast-name]').textContent = item.product_title || item.title || '';
    t.querySelector('[data-gz-toast-meta]').textContent = 'Qty ' + item.quantity + ' · ' + money(item.final_price / 100, 2);

    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var thr = Math.ceil(parseFloat(t.dataset.thresholdUsd || '199') * rate);
    var sub = cart.items_subtotal_price / 100;
    var remaining = thr - sub;
    var pct = Math.max(0, Math.min(100, Math.floor((sub * 100) / thr)));
    t.classList.toggle('is-unlocked', remaining <= 0);
    t.querySelector('[data-gz-toast-msg]').textContent = remaining <= 0
      ? "You've unlocked FREE shipping!"
      : "You're " + money(remaining, remaining < 100 ? 2 : 0) + ' away from free shipping';
    t.querySelector('[data-gz-toast-fill]').style.width = pct + '%';

    t.hidden = false;
    // restart the entrance animation
    t.classList.remove('is-open');
    void t.offsetWidth;
    t.classList.add('is-open');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeToast, 9000);
  }

  window.gzShowToast = showToast; // used by snippets/gz-atc-extras.liquid

  document.addEventListener('click', function (e) {
    var close = e.target.closest ? e.target.closest('.gz-toast__x') : null;
    if (close) { closeToast(); return; }
    var btn = e.target.closest ? e.target.closest('[data-gz-add]') : null;
    if (!btn || btn.disabled || btn.classList.contains('is-adding')) return;
    e.preventDefault();
    setState(btn, 'adding');
    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(btn.getAttribute('data-gz-add')), quantity: 1 })
    })
      .then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      })
      .then(function (item) {
        return fetch(CART_URL, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCount(cart);
            showToast(item, cart);
            setState(btn, 'done');
            setTimeout(function () { setState(btn, 'idle'); }, 2800);
          });
      })
      .catch(function (err) {
        btn.title = (err && err.description) ? err.description : 'Could not add this item. Please try again.';
        setState(btn, 'error');
        setTimeout(function () { setState(btn, 'idle'); btn.removeAttribute('title'); }, 3500);
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeToast();
  });

  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest('#gz-toast')) clearTimeout(closeTimer);
  });
})();
